<template>
  <b-form-group
    label="E-mail"
    label-for="email"
    description="Digite seu e-mail"
  >
    <b-form-input
      id="email"
      v-model="email"
      type="email"
      placeholder="email@exemplo.com"
      required
      :state="emailState"
      aria-describedby="email-feedback"
      @blur="validateEmail"
    ></b-form-input>
    <b-form-invalid-feedback id="email-feedback">
      Por favor, insira um e-mail válido.
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  name: 'EmailInput',
  props: {
    value: {
      type: String,
      required: true,
    },
    state: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      emailState: this.state,
    };
  },
  computed: {
    email: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  watch: {
    state(newValue) {
      this.emailState = newValue;
    },
  },
  mounted() {
    if (this.value) {
      this.validateEmail();
    }
  },
  methods: {
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.emailState = emailRegex.test(this.value) ? true : false;
      this.$emit('validation-updated', this.emailState);
    },
  },
};
</script>
